angular.module('app.ui.form.ctrls')
.directive('clearIcon', ['$compile',
    function($compile) {
	return {
		restrict : 'A',
		link : function(scope, elem, attrs) {
			var model = attrs.ngModel;
			var template = '<span ng-click=\"clearText(\'' + model + '\')\" class="clearIcon"             style="display:none;">x</span>';
			elem.parent().append($compile(template)(scope));
			var clearIconToggle = function(toggleParam) {
				if(elem.val().trim().length)
					elem.next().css("display", "inline");
				else {
					if(elem.next().css("display") == "inline")
						elem.next().css("display", "none");
				}
			};
			var clearText = function(clearParam) {
				elem.val('');
				clearIconToggle(clearParam);
			};
			elem.on("focus", function(event) {
				clearIconToggle(model);
			});
			elem.on("keyup", function(event) {
				clearIconToggle(model);
			});
			elem.next().on("click", function(event) {
				elem.val('');
				elem.next().css("display", "none");
			});
		}
	}; }]);


// WEBPACK FOOTER //
// ./scripts/shared/clear-icon.js